"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CommandRequest = void 0;

var _command_pb = require("../proto/spine/core/command_pb");

var _diagnostics_pb = require("../proto/spine/core/diagnostics_pb");

var _actorRequestFactory = require("./actor-request-factory");

var _anyPacker = require("./any-packer");

var _clientRequest = require("./client-request");

var _typedMessage = require("./typed-message");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var NOOP_CALLBACK = function NOOP_CALLBACK() {};
/**
 * A request to post a command to the Spine backend.
 *
 * Optionally allows to subscribe to events that are the immediate results of handling the command.
 *
 * A usage example:
 * ```
 * client.command(logInUser)
 *       .onOk(_logOk)
 *       .onError(_logError)
 *       .onImmediateRejection(_warnAboutRejection)
 *       .observe(UserLoggedIn.class, ({subscribe, unsubscribe}) => {
 *           subscribe(event => _logAndUnsubscribe(event, unsubscribe));
 *           setTimeout(unsubscribe, EVENT_WAIT_TIMEOUT);
 *       })
 *       .observe(UserAlreadyLoggedIn.class, (({subscribe, unsubscribe}) => {
 *           subscribe(event => _warnAboutAndUnsubscribe(event, unsubscribe));
 *           setTimeout(unsubscribe, EVENT_WAIT_TIMEOUT);
 *       })
 *       .post();
 * ```
 *
 * The `subscribe` callback provided to the consumer allows to configure an event receival process
 * while the `unsubscribe` callback allows to cancel the subscription.
 *
 * Please note that in the example above we make sure the subscription is cancelled even if the
 * specified event type is never received.
 */


var CommandRequest = /*#__PURE__*/function (_ClientRequest) {
  _inherits(CommandRequest, _ClientRequest);

  var _super = _createSuper(CommandRequest);

  /**
   * @param {!Message} commandMessage the command to post
   * @param {!Client} client the client which initiated the request
   * @param {!ActorRequestFactory} actorRequestFactory the request factory
   */
  function CommandRequest(commandMessage, client, actorRequestFactory) {
    var _this;

    _classCallCheck(this, CommandRequest);

    _this = _super.call(this, client, actorRequestFactory);
    _this._commandMessage = commandMessage;
    _this._onAck = NOOP_CALLBACK;
    _this._onError = NOOP_CALLBACK;
    _this._onImmediateRejection = NOOP_CALLBACK;
    _this._observedTypes = [];
    return _this;
  }
  /**
   * Runs the callback if the command is successfully handled by the Spine server.
   *
   * @param {!parameterlessCallback} callback the callback to run
   * @return {this} self for method chaining
   */


  _createClass(CommandRequest, [{
    key: "onOk",
    value: function onOk(callback) {
      this._onAck = callback;
      return this;
    }
    /**
     * Runs the callback if the command could not be handled by the Spine server due to a
     * technical error.
     *
     * @param {!consumerCallback<CommandHandlingError>} callback the callback to run
     * @return {this} self for method chaining
     */

  }, {
    key: "onError",
    value: function onError(callback) {
      this._onError = callback;
      return this;
    }
    /**
     * Runs the callback if the server responded on a command with an immediate rejection.
     *
     * The immediate rejection means the command did not pass the command filters set up in the
     * bounded context and was disqualified from execution right away.
     *
     * A typical example of this would be the command not passing filters due to user permissions
     * being not broad enough.
     *
     * Please note that this rejection is different to a "normal" rejection when the command is
     * acknowledged with the `OK` status and then reaches the handler method which processes it. Such
     * rejections can be tracked using the `observe(...)` method of this request.
     *
     * @param {!consumerCallback<spine.core.Event>} callback
     * @return {this} self for method chaining
     */

  }, {
    key: "onImmediateRejection",
    value: function onImmediateRejection(callback) {
      this._onImmediateRejection = callback;
      return this;
    }
    /**
     * Adds the event type to the list of observed command handling results.
     *
     * @param {!Class<Message>} eventType a type of the observed events
     * @param {!consumerCallback<EventSubscriptionCallbacks>} consumer
     *        a consumer of the `subscribe` and `unsubscribe` callbacks which are responsible for
     *        accepting the incoming events and cancelling the subscription respectively
     * @return {this} self for method chaining
     */

  }, {
    key: "observe",
    value: function observe(eventType, consumer) {
      this._observedTypes.push({
        type: eventType,
        consumer: consumer
      });

      return this;
    }
    /**
     * Posts the command to the server and subscribes to all observed types.
     *
     * @return {Promise<void>} a promise that signals if the command posting was done successfully,
     *                         may be ignored
     */

  }, {
    key: "post",
    value: function post() {
      var _this2 = this;

      var command = this._requestFactory.command().create(this._commandMessage);

      var onAck = {
        onOk: this._onAck,
        onError: this._onError,
        onImmediateRejection: this._onImmediateRejection
      };
      var promises = [];

      this._observedTypes.forEach(function (_ref) {
        var type = _ref.type,
            consumer = _ref.consumer;

        var originFilter = _actorRequestFactory.Filters.eq("context.past_message", _this2._asOrigin(command));

        var promise = _this2._client.subscribeToEvent(type).where(originFilter).post().then(function (_ref2) {
          var eventEmitted = _ref2.eventEmitted,
              unsubscribe = _ref2.unsubscribe;

          var subscribe = function subscribe(eventConsumer) {
            eventEmitted.subscribe({
              next: eventConsumer
            });
          };

          consumer({
            subscribe: subscribe,
            unsubscribe: unsubscribe
          });
        });

        promises.push(promise);
      });

      var subscriptionPromise = Promise.all(promises);
      return subscriptionPromise.then(function () {
        return _this2._client.post(command, onAck);
      });
    }
    /**
     * @param {!Command} command
     * @return {Origin}
     *
     * @private
     */

  }, {
    key: "_asOrigin",
    value: function _asOrigin(command) {
      var result = new _diagnostics_pb.Origin();
      var messageId = new _diagnostics_pb.MessageId();

      var commandIdType = _typedMessage.Type.forClass(_command_pb.CommandId);

      var packedId = _anyPacker.AnyPacker.pack(command.getId()).as(commandIdType);

      messageId.setId(packedId);
      var typeUrl = command.getMessage().getTypeUrl();
      messageId.setTypeUrl(typeUrl);
      result.setMessage(messageId);
      var actorContext = command.getContext().getActorContext();
      result.setActorContext(actorContext);
      return result;
    }
  }]);

  return CommandRequest;
}(_clientRequest.ClientRequest);

exports.CommandRequest = CommandRequest;
//# sourceMappingURL=command-request.js.map